import { render, staticRenderFns } from "./CartaoEdicaoObservacao.vue?vue&type=template&id=cc9f1b26"
import script from "./CartaoEdicaoObservacao.vue?vue&type=script&lang=js"
export * from "./CartaoEdicaoObservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports